var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',{staticStyle:{"text-align":"center","margin":".1rem 0"},attrs:{"current-page":_vm.currentPage,"layout":"total, prev, pager, next","total":_vm.total,"page-size":_vm.size,"next-click":"onNextClick"},on:{"current-change":_vm.handleCurrentChange}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e6af6f7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Education/commonView/Pagination.vue
// module id = null
// module chunks = 